import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hiddenField" ]

  connect() {
    // console.log("Hello, Approve Content Controller here!", this.element)
  }

  approveContent(event) {
    if (event.target.dataset.confirmSwal) {
      // need to confirm first
      return;
    }

    this.hiddenFieldTarget.value = 'true';

    if (event.params.text) {
      event.target.innerText = event.params.text;
    }
    event.target.setAttribute('disabled', 'disabled');
    this.hiddenFieldTarget.form.submit();
  }

}
